import { css } from "@umbraco-cms/backoffice/external/lit";
import { appendStyles, interceptLitElement } from "../utils/lit";

// Apply custom backoffice styling for which the shadow DOM needs to be intercepted.
// For all other styling changes, see 'extensions/backoffice-styling/backoffice-styling.css'.

// Custom header styling (add a green border on top, and a gray one at the bottom)
interceptLitElement("umb-backoffice-header", constructor => {
    appendStyles(constructor, css`
            :host {
                border-style: solid;
                border-width: 10px;
                border-image: linear-gradient(90deg, #00e075 0%, #007544 100%) 1 0 0 0;
                border-left: none;
                border-right: none;
                border-bottom: none;
                margin-bottom: 0;
            }

            #appHeader {
                border-bottom: 1px solid #ebebeb;
            }
        `);

    return constructor;
});

// Fix the height of the main workspace, due to our custom border in the header causing extra offset
interceptLitElement("umb-backoffice-main", constructor => {
    appendStyles(constructor, css`
            :host {
                height: calc(100% - 70px);
            }
        `);

    return constructor;
});

// Prevent being able to click the logo in the header, since that shows Umbraco info which is not relevant for Strada users
interceptLitElement("umb-backoffice-header-logo", constructor => {
    appendStyles(constructor, css`
            :host {
                pointer-events: none;
            }

            @media screen and (max-width: 650px) {
                #header-logo-button {
                    display: none;
                }
            }
        `);

    return constructor;
});

// Make the icon in the 'Sign in with Strada' button white (instead of globally setting the --uui-icon-color variable,
// since then all icons are affected, and we need them to be black in almost all other cases):
interceptLitElement("umb-auth-provider-default", constructor => {
    appendStyles(constructor, css`
            #icon {
                --uui-icon-color: white;
            }
        `);

    return constructor;
});
